module.exports = "data:image/gif;base64,R0lGODlhAwAGAIAAAP7+/qXOVSH5BAAAAAAALAAAAAADAAYAAAIGDBCWu3gFADs="